import {
	getRedirectResult,
	GoogleAuthProvider,
	signInWithPopup,
	signInWithRedirect,
} from "firebase/auth";
import type { Auth, UserCredential } from "firebase/auth";

const createGoogleProvider = () => {
	const provider = new GoogleAuthProvider();
	provider.setCustomParameters({
		prompt: "select_account",
	});

	return provider;
};

export const signInWithGooglePopup = async (
	auth: Auth,
): Promise<UserCredential> => {
	return signInWithPopup(auth, createGoogleProvider());
};

export const signInWithGoogleRedirect = async (auth: Auth) => {
	return signInWithRedirect(auth, createGoogleProvider());
};

export const getGoogleRedirectResult = async (auth: Auth) => {
	return getRedirectResult(auth);
};

export const shouldUseGoogleRedirectFallback = (error: unknown) => {
	const errorCode =
		typeof error === "object" && error !== null && "code" in error
			? String((error as { code?: string }).code)
			: "";

	return (
		errorCode === "auth/popup-blocked" ||
		errorCode === "auth/popup-timeout" ||
		errorCode === "auth/cancelled-popup-request"
	);
};

export const getGoogleAuthErrorMessage = (error: unknown) => {
	const errorCode =
		typeof error === "object" && error !== null && "code" in error
			? String((error as { code?: string }).code)
			: "";

	if (
		errorCode === "auth/popup-closed-by-user" ||
		errorCode === "auth/cancelled-popup-request"
	) {
		return "Google sign-in was cancelled. Please try again.";
	}

	if (errorCode === "auth/popup-blocked") {
		return "Popup was blocked. Please allow popups and try again.";
	}

	if (errorCode === "auth/unauthorized-domain") {
		return "This domain is not authorized for Google sign-in.";
	}

	if (errorCode === "auth/popup-timeout") {
		return "Google sign-in did not complete. Please try again.";
	}

	return "Google sign-in failed. Please try again.";
};
